import Menu from './Menu.mapper';

export default Menu;
